import { createFileRoute } from '@tanstack/react-router';
import { OutboxRouteView } from '@/pages/workspaces/journeys/outbox/outbox-route-view';

function MessageActivityRoute() {
  const { workspaceId, _splat } = Route.useParams();
  return <OutboxRouteView segment="message_activity" workspaceId={workspaceId} splat={_splat ?? ''} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/message_activity/$')({
  component: MessageActivityRoute,
});
